import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from 'spark-core-dx/contexts';
import MarketplaceExperience from './components/MarketplaceExperience';
import MarketplaceDomain from './MarketplaceDomain';

const normalizeBasePath = (basePath) => {
  const normalized = basePath || '/marketplace';
  const absolutePath = normalized.startsWith('/') ? normalized : `/${normalized}`;
  return absolutePath.length > 1 ? absolutePath.replace(/\/+$/, '') : absolutePath;
};

const MarketplaceRoute = ({ basePath, legacy = false }) => {
  const { isAuthorized } = useAuthContext();
  const location = useLocation();
  const normalizedBasePath = normalizeBasePath(basePath);

  if (legacy) {
    const legacySuffix = location.pathname.replace(/^\/Marketplace/, '');
    const lowerPath = `${normalizedBasePath}${legacySuffix}`;
    return <Navigate to={`${lowerPath}${location.search}${location.hash}`} replace />;
  }

  if (isAuthorized) {
    return (
      <MarketplaceDomain>
        <MarketplaceExperience mode="secure" basePath={normalizedBasePath} />
      </MarketplaceDomain>
    );
  }

  return <MarketplaceExperience mode="public" basePath={normalizedBasePath} />;
};

export default MarketplaceRoute;
